exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/*textarea {\r\n  height: 90px !important;\r\n}*/\n.require-textarea-1 {\n  border-left: 2px solid #F95372; }\n\n.require-textarea-2 {\n  border-left: 2px solid #42A948; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/complaints/complaints-resolution/components/manager-complaint/manager-complaint.component.scss
// module id = 2000
// module chunks = 66